@let informationsPratiques = formService.informationsPratiques.value;
@let aptitudes = formService.aptitudes.value;
@let interrelations = formService.interrelations.value;
@let productions = formService.productions.value;

<div class="flex h-full flex-col overflow-y-hidden">
  <div class="border-stroke-neutral-light p-lg flex w-full justify-between border-b bg-white">
    <div class="gap-xxs flex">
      <a [routerLink]="[idActivite() ? '../../' + idActivite() : '../../../..']" size="xxl" hlmBtn variant="ghost">
        <ng-icon hlm name="lucideArrowLeft" />
      </a>
      <div class="flex flex-col">
        <h1 class="title-medium-semibold text-content-primary">
          {{ idActivite() ? formService.nom.value : 'Nouvelle activité' }}
        </h1>
        <span class="text-content-secondary">Les informations renseignées sont enregistrées automatiquement.</span>
      </div>
    </div>

    <div>
      <div class="gap-xs flex">
        @if (etape() > 0) {
          <a [routerLink]="['.']" [queryParams]="{ i: etape() - 1 }" hlmBtn type="button" variant="secondary"
            >Retourner à l'étape précédente</a
          >
        }
        @if (etape() < 4) {
          <a [routerLink]="['.']" [queryParams]="{ i: etape() + 1 }" hlmBtn type="button">Aller à l'étape suivante</a>
        } @else {
          @if (formService.form.enabled) {
            <button (click)="publierActivite()" hlmBtn type="button">Publier l'activité</button>
          } @else {
            <a [routerLink]="['../..', idActivite()]" hlmBtn type="button">Revenir sur la séquence</a>
          }
        }
      </div>
    </div>
  </div>
  <div class="py-xl overflow-y-auto">
    <div class="gap-lg mx-auto flex w-3/4 flex-col lg:w-1/2">
      @if (etape() === 0) {
        <section class="!p-lg bg-white" hlmCard>
          <div class="!p-0" hlmCardContent>
            <app-informations-pratiques [form]="formService.informationsPratiques" />
          </div>
        </section>
      } @else {
        <app-item-resume [index]="0" [invalid]="formService.informationsPratiques.invalid">
          <span
            >1.
            <span class="text-components-content-primary-main paragraph-medium-medium">{{
              informationsPratiques.nom ?? "Nom de l'activité"
            }}</span>
            est une activité du métier
            <span class="text-components-content-primary-main paragraph-medium-medium">{{
              informationsPratiques.referentiel?.nom ?? 'Métier'
            }}</span
            >. Elle se déroule en
            <span class="text-components-content-primary-main paragraph-medium-medium">{{
              informationsPratiques.modalite?.nom ?? 'Modalités'
            }}</span>
            en
            <span class="text-components-content-primary-main paragraph-medium-medium">{{
              informationsPratiques.lieu ?? 'Lieu'
            }}</span>
            pendant
            <span class="text-components-content-primary-main paragraph-medium-medium">{{
              informationsPratiques.duree ? informationsPratiques.duree + 'h' : 'Durée'
            }}</span
            >. Elle contient une description et utilise
            <span class="text-components-content-primary-main paragraph-medium-medium">{{
              informationsPratiques.techniquesAnimation.length
                ? (informationsPratiques.techniquesAnimation | joinBy: 'libelle')
                : "Techniques d'animation"
            }}</span
            >.</span
          >
        </app-item-resume>
      }

      @if (etape() === 1) {
        <section class="!p-lg bg-white" hlmCard>
          <div class="!p-0" hlmCardContent>
            <app-aptitudes [form]="formService.aptitudes" [formService]="formService" />
          </div>
        </section>
      } @else if (etape() > 1) {
        <app-item-resume [index]="1" [invalid]="formService.aptitudes.invalid">
          <span
            >2. L’aptitude principale
            <span class="text-components-content-primary-main paragraph-medium-medium">
              @if (aptitudes.aptitudePrincipale.aptitude) {
                {{ aptitudes.aptitudePrincipale.aptitude?.referentiel }} •
                {{ aptitudes.aptitudePrincipale.aptitude?.nom }}
              } @else {
                Aptitude
              }
            </span>
            @if (aptitudes.aptitudePrincipale.estEvaluee) {
              est <span class="text-components-content-primary-main paragraph-medium-medium">évaluée</span>.
            } @else {
              n'est <span class="text-components-content-primary-main paragraph-medium-medium">pas évaluée</span>.
            }
            <br />

            @if (aptitudes.aptitudesSecondaires) {
              Les aptitudes secondaires :
              <div class="ml-md">
                @for (control of aptitudes.aptitudesSecondaires; track $index) {
                  <li>
                    <ul>
                      <span class="text-components-content-primary-main paragraph-medium-medium">
                        {{ control.aptitude.referentiel }} • {{ control.aptitude.nom }}
                      </span>
                      @if (control.aptitude.estEvaluee) {
                        est <span class="text-components-content-primary-main paragraph-medium-medium">évaluée</span>.
                      } @else {
                        n'est
                        <span class="text-components-content-primary-main paragraph-medium-medium">pas évaluée</span>.
                      }
                    </ul>
                  </li>
                }
              </div>
            }
          </span>
        </app-item-resume>
      }

      @if (etape() === 2) {
        <section class="!p-lg bg-white" hlmCard>
          <div class="!p-0" hlmCardContent>
            <app-interrelations [formService]="formService" />
          </div>
        </section>
      } @else if (etape() > 2) {
        <app-item-resume [index]="2" [invalid]="formService.interrelations.invalid">
          <span
            >3. Les interrelations sélectionnées sont
            <span class="text-components-content-primary-main paragraph-medium-medium">{{
              interrelations.length ? (interrelations | joinBy: 'nom') : 'Interrelations'
            }}</span
            >.</span
          >
        </app-item-resume>
      }

      @if (etape() === 3) {
        <section class="!p-lg bg-white" hlmCard>
          <div class="!p-0" hlmCardContent>
            <app-productions [formService]="formService" />
          </div>
        </section>
      } @else if (etape() > 3) {
        <app-item-resume [index]="3" [invalid]="formService.productions.invalid">
          <span
            >4. Les productions sélectionnées sont
            <span class="text-components-content-primary-main paragraph-medium-medium">{{
              productions.length ? (productions | joinBy: 'nom') : 'Productions'
            }}</span
            >.</span
          >
        </app-item-resume>
      }

      @if (etape() === 4) {
        <section class="!p-lg bg-white" hlmCard>
          <div class="!p-0" hlmCardContent>
            <app-supports [formService]="formService" />
          </div>
        </section>
      }
    </div>
  </div>
</div>
